import { createSlice } from "@reduxjs/toolkit";

export const holidayReducer = createSlice({
  name: "holiday",
  initialState: [
    // {
    //   id: "",
    //   leaveType: "",
    //   attachedFile: [""],
    //   dateRange: [null, null],
    //   additionalNotes: "",
    //   status: "",
    //   type: "holiday",
    //   isDraft: false,
    // },
  ],
  reducers: {
    addHoliday: (state, action) => {
      state.push(action.payload);
    },
    removeHoliday: (state, action) => {
      return state.filter((holiday) => holiday.id !== action.payload.id);
    },
    updateHoliday: (state, action) => {
      const index = state.findIndex(
        (holiday) => holiday.id === action.payload.id,
      );
      if (index !== -1) {
        state[index] = { ...state[index], ...action.payload };
      }
    },
  },
});

export const { addHoliday, removeHoliday, updateHoliday } =
  holidayReducer.actions;
export default holidayReducer.reducer;